export const SPACE_KEY = 'Space'

export const ARROW_LEFT_KEY = 'ArrowLeft'

export const ARROW_RIGHT_KEY = 'ArrowRight'

export const ARROW_UP_KEY = 'ArrowUp'

export const ARROW_DOWN_KEY = 'ArrowDown'

export const BACKSPACE_KEY = 'Backspace'

export const DELETE_KEY = 'Delete'
